<div class="container p-4" >
    <div class="card p-5">

        <div class='container'>

            <h3><i style="color:red;" class="fa fa-times-circle"></i> Error receiving payment</h3>
            <p>There was a problem paying using knet. for more information please contact your card issuer.</p>
        </div>


    </div>


</div>

